<script lang="ts">
    import type {AxiosInstance} from 'axios';

    import {dyData} from 'general/store';
    import {TEMPLATE} from 'general/constants';

    import Description from 'general/components/description/Description.svelte';
    import Form from 'general/components/form/email/Form.svelte';
    import Policy from 'general/components/policy/Policy.svelte';
    import Logo from 'general/components/logo/Logo.svelte';
    import ScrollItem from 'general/components/scrollItem/ScrollItem.svelte';
    import TrustpilotAlt from 'desktop/components/trustpilotAlt/TrustpilotAlt.svelte';

    import s from './style.module.css';

    export let instance: AxiosInstance;
    let errorMessage: string;
</script>

<ScrollItem>
    <div class={s.main} style="margin-top: {$dyData.side.main?.marginTop || 0}">
        <Logo side="main" />
        <Description template={TEMPLATE.SQUARE_PRODUCT} value={$dyData.description?.main} />
        <Form
            {instance}
            offerGiven={$dyData.offerGiven}
            template={TEMPLATE.SQUARE_PRODUCT}
            marginBottom={errorMessage ? '20px' : '13px'}
            bind:errorMessage
        />
        <div class={s.divider} />
        <TrustpilotAlt />
        <Policy padding="20px 25px 0 25px" />
    </div>
</ScrollItem>
